// components/landing/LoadingSkeleton.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function LoadingSkeleton() {
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate "processing" for ~1 second
    const timer = setTimeout(() => {
      navigate('/score/email');
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <p>Analyzing your portfolio...</p>
      {/* You can add spinners or skeleton UI here */}
    </div>
  );
}

export default LoadingSkeleton;
